export const translations = {
  es: {
    common: {
      close: 'Cerrar',
      openInNewTab: 'Abrir en pestaña nueva',
    },
    nav: {
      servicios: 'SERVICIOS',
      proyectos: 'PROYECTOS',
      colaboraciones: 'COLABORACIONES',
      contacto: 'CONTACTO',
    },
    hero: {
      subtitle: 'Pop-Ups & Stands',
      logoAlt: 'HOME',
      scrollIndicator: 'Desliza para ver más',
    },
    servicios: {
      title: 'SERVICIOS',
      subtitle: 'Nos dedicamos a idear y ejecutar experiencias BTL en CC y eventos',
      items: {
        popUps: 'Pop Ups',
        testDrive: 'Test Drive',
      },
    },
    proyectos: {
      title: 'PROYECTOS',
      openProject: 'Abrir proyecto',
      f1: {
        description:
          'Experiencias inmersivas de Formula 1 con simuladores de carreras, activaciones de marca y pop-ups temáticos en centros comerciales y eventos.',
      },
      kylie: {
        description:
          'Pop-ups exclusivos y stands interactivos para Kylie Cosmetics, creando experiencias de belleza únicas y personalizadas.',
      },
      nissan: {
        description:
          'Test drives experienciales y stands innovadores para Nissan, conectando con los clientes a través de la tecnología y la emoción de conducir.',
      },
      volvo: {
        description:
          'Espacios premium y test drives exclusivos para Volvo, comunicando seguridad, sustentabilidad y diseño escandinavo.',
      },
    },
    colaboraciones: {
      title: 'COLABORACIONES',
      imageAlt: 'Colaboraciones HOME — F1, Kylie Cosmetics, Nissan, Volvo',
    },
    footer: {
      title: 'Deja tu huella',
      subtitle: 'Contáctanos',
      form: {
        name: 'Nombre completo*',
        email: 'Email*',
        phone: 'Teléfono*',
        message: 'Mensaje*',
        submit: 'Enviar por WhatsApp',
      },
      errors: {
        name: 'Por favor ingresa tu nombre',
        emailRequired: 'Por favor ingresa tu email',
        emailInvalid: 'Por favor ingresa un email válido',
        phone: 'Por favor ingresa tu teléfono',
        message: 'Por favor ingresa un mensaje',
      },
      whatsapp: {
        greeting: '¡Hola H Group, me interesa colaborar con HOME!',
        intro: 'Me gustaría ponerme en contacto con ustedes.',
        dataHeader: 'Mis datos:',
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        messageHeader: 'Mensaje',
        signature: 'Enviado desde el formulario de contacto de HOME',
      },
      addressAria: 'Ver dirección en Google Maps',
    },
  },
  en: {
    common: {
      close: 'Close',
      openInNewTab: 'Open in new tab',
    },
    nav: {
      servicios: 'SERVICES',
      proyectos: 'PROJECTS',
      colaboraciones: 'COLLABORATIONS',
      contacto: 'CONTACT',
    },
    hero: {
      subtitle: 'Pop-Ups & Stands',
      logoAlt: 'HOME',
      scrollIndicator: 'Scroll for more',
    },
    servicios: {
      title: 'SERVICES',
      subtitle: 'We design and produce BTL experiences in shopping centers and events',
      items: {
        popUps: 'Pop Ups',
        testDrive: 'Test Drive',
      },
    },
    proyectos: {
      title: 'PROJECTS',
      openProject: 'Open project',
      f1: {
        description:
          'Immersive Formula 1 experiences with race simulators, brand activations and themed pop-ups in shopping centers and events.',
      },
      kylie: {
        description:
          'Exclusive pop-ups and interactive stands for Kylie Cosmetics, creating unique, personalized beauty experiences.',
      },
      nissan: {
        description:
          'Experiential test drives and innovative stands for Nissan, connecting with customers through technology and the thrill of driving.',
      },
      volvo: {
        description:
          'Premium spaces and exclusive test drives for Volvo, communicating safety, sustainability and Scandinavian design.',
      },
    },
    colaboraciones: {
      title: 'COLLABORATIONS',
      imageAlt: 'HOME collaborations — F1, Kylie Cosmetics, Nissan, Volvo',
    },
    footer: {
      title: 'Leave your mark',
      subtitle: 'Contact us',
      form: {
        name: 'Full name*',
        email: 'Email*',
        phone: 'Phone*',
        message: 'Message*',
        submit: 'Send via WhatsApp',
      },
      errors: {
        name: 'Please enter your name',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Please enter a valid email',
        phone: 'Please enter your phone number',
        message: 'Please enter a message',
      },
      whatsapp: {
        greeting: 'Hi H Group, I would like to collaborate with HOME!',
        intro: 'I would like to get in touch with you.',
        dataHeader: 'My details:',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        messageHeader: 'Message',
        signature: 'Sent from the HOME contact form',
      },
      addressAria: 'Open address in Google Maps',
    },
  },
};

export const DEFAULT_LANGUAGE = 'es';
export const SUPPORTED_LANGUAGES = Object.keys(translations);
